export default __webpack_public_path__ + "static/media/SAVITRI_KOMSHIRASANGI.276b58d4.JPG";